module.exports = __webpack_public_path__ + "img/dianshi.4abf990e.svg";